var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgServiceShield = function SvgServiceShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 107,
    viewBox: "0 0 85 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "service",
    clipPath: "url(#clip0_3818_264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M42.5 106.65L41.7465 106.223C16.0053 91.4341 0 63.6556 0 33.6818V15.4779H1.50709C14.8599 15.4779 27.7004 11.3309 38.5816 3.46395L42.5301 0.628174L46.4787 3.46395C57.3599 11.3309 70.1702 15.4779 83.5532 15.4779H85.0603V33.6818C85.0603 63.6556 69.055 91.4341 43.2837 106.223L42.5301 106.65H42.5ZM3.01418 18.4966V33.6818C3.01418 62.253 18.1152 88.7812 42.5 103.143C66.8848 88.7812 81.9858 62.253 81.9858 33.6818V18.4966C68.5425 18.1917 55.672 13.8618 44.6702 5.93382L42.4699 4.34823L40.2695 5.93382C29.328 13.8923 16.4574 18.2222 3.01418 18.4966Z",
    fill: "#10A2FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42.4999 96.0079L41.656 95.4286C21.2499 81.6156 9.04248 58.5329 9.04248 33.6818V24.2597L10.3687 24.1072C21.6418 22.7351 32.1613 18.8016 41.6861 12.4287L42.5301 11.8798L43.374 12.4287C52.8687 18.8016 63.4184 22.7351 74.6914 24.1072L76.0177 24.2597V33.6818C76.0177 58.5329 63.8102 81.6156 43.4042 95.4286L42.5602 96.0079H42.4999ZM12.0567 26.943V33.6818C12.0567 57.1608 23.4201 78.9932 42.4999 92.3183C61.5797 79.0237 72.9432 57.1608 72.9432 33.6818V26.943C62.0318 25.4184 51.8138 21.5764 42.4999 15.5084C33.1861 21.5764 22.968 25.4184 12.0567 26.943Z",
    fill: "#10A2FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.4963 69.8455L23.2393 55.4227L30.413 48.1655L37.4963 55.3312L54.6471 37.9811L61.8208 45.2383L37.5265 69.815L37.4963 69.8455ZM27.4893 55.4227L37.4963 65.5461L57.5407 45.2688L54.6471 42.3415L37.4963 59.6916L30.413 52.5259L27.5194 55.4837L27.4893 55.4227Z",
    fill: "#10A2FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3818_264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 106.022,
    fill: "white",
    transform: "translate(0 0.628174)"
  })))));
};
export default SvgServiceShield;